import { z } from "zod";

export enum EPdlStatus {
  VALID = "VALID",
  FORCED_VALID = "FORCED_VALID",
  PROCESSING = "PROCESSING",
  FORCED_INVALID = "FORCED_INVALID",
  INVALID = "INVALID",
  NOT_VERIFIED = "NOT_VERIFIED",
  NOT_ENEDIS = "NOT_ENEDIS",
}

export const sitePdlDto = z.object({
  pdl: z.string().nullable(),
  status: z.nativeEnum(EPdlStatus),
});

export type TSitePdlDto = z.infer<typeof sitePdlDto>;
